import React from 'react';

const NavContext = React.createContext({
    navContent: null,
    setNavContent: () => { }
});

export default NavContext;
